import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';
import { useMsal } from "@azure/msal-react";

import './user_list.scss';

import {
    DataGrid,
    Sorting, Selection, HeaderFilter, Scrolling, SearchPanel,
    Export, Column, Toolbar, Item, LoadPanel

} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';


import { FormPopup, UserNewForm, UserPanel } from '../../components';
import { UserStatus } from '../../components';

import { exportFormats, USER_STATUS_LIST } from '../../shared/constants';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate } from 'react-router-dom';
import { onExporting } from '../../utils/exporter';

const filterStatusList = ['alle', ...USER_STATUS_LIST];

const cellNameRender = (cell) => (
    <div className='name-template'>
        <div>{cell.data.surname} {cell.data.lastname}</div>
        <div className='position'>{cell.data.position}</div>
    </div>
);

const editCellStatusRender = () => (
    <SelectBox className='cell-info' dataSource={USER_STATUS_LIST} itemRender={UserStatus} fieldRender={fieldRender} />
);


const fieldRender = (text) => (
    <>
        <UserStatus text={text} />
        <TextBox readOnly />
    </>
);



const dropDownOptions = { width: 'auto' };



export const UserList = () => {
    
    const { instance, accounts } = useMsal();
    const [gridDataSource, setGridDataSource] = useState();
    const [dataSource_permissiongroup, setdataSource_permissiongroup] = useState();

    const [isPanelOpened, setPanelOpened] = useState(false);
    const [userId, setUserId] = useState();
    const [popupVisible, setPopupVisible] = useState(false);
    const [formDataDefaults, setFormDataDefaults] = useState({ isEntraUser: false });
    const gridRef = useRef(null);
    const navigate = useNavigate();

    let newUserData;

    useEffect(() => {
        getApiToken(instance, accounts).then(token => {
            setGridDataSource({
                store: createStore({
                    key: 'userId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/User/Users`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/User/InsertUser`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/User/UpdateUser`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/User/DeleteUser`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: ['status', '=', filterStatusList[1]]
            });

            const dataSource_permissiongroup = createStore({
                key: 'permissiongroupId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/PermissiongroupsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });

            dataSource_permissiongroup.load().done(function (data) {
                setdataSource_permissiongroup(data);
            })

        });

    }, []);

    const changePopupVisibility = useCallback((isVisble) => {
        setPopupVisible(isVisble);
    }, []);

    const changePanelOpened = useCallback(() => {

        setPanelOpened(!isPanelOpened);
        gridRef.current?.instance().option('focusedRowIndex', -1);
    }, [isPanelOpened]);

    const changePanelPinned = useCallback(() => {
        gridRef.current?.instance().updateDimensions();
    }, []);

    const onAddUserClick = useCallback(() => {
        setPopupVisible(true);
    }, []);

    const onRowClick = useCallback(({ data }) => {
        // setUserId(data.userId);
        // setPanelOpened(true);
        const userId = data.userId;
        navigate(`/user/edit/${userId}`);
    }, []);

    const [status, setStatus] = useState(filterStatusList[1]);

    const filterByStatus = useCallback((e) => {
        const { item: status } = e;
        if (status === 'alle') {
            gridRef.current?.instance().clearFilter();
        } else {
            gridRef.current?.instance().filter(['status', '=', status]);
        }

        setStatus(status);
    }, []);

    const refresh = useCallback(() => {
        gridRef.current?.instance().refresh();
    }, []);

    const onDataChanged = useCallback((data) => {
        newUserData = data;
    }, []);

    const onSaveClick = useCallback(() => {



        getApiToken(instance, accounts).then(token => {
            const datastore = createStore({
                key: 'userId',
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/User/InsertUser`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });

            datastore.insert(newUserData).then((data) => {

                notify({
                    message: `Neuer Benutzer "${data.displayName}" gespeichert`,
                    position: { at: 'bottom center', my: 'bottom center' }
                }
                    ,
                    'success'
                );
                setFormDataDefaults({ ...formDataDefaults });
                setPopupVisible(false);
                refresh();
            }).catch((error) => {
   
                notify({
                    message: `Fehler beim Speichern des neuen Benutzers "${newUserData.displayName}": ${error?.response?.data?.message || error?.message || error}`,
                    position: { at: 'bottom center', my: 'bottom center' }
                },
                    'error'
                );
            });
        });
    }, []);

    return (
        <div className='view user-list'>
            <div className='view-wrapper view-wrapper-user-list list-page'>
                <DataGrid
                    className='grid theme-dependent'
                    noDataText=''
                    focusedRowEnabled
                    height='100%'
                    dataSource={gridDataSource}
                    onRowClick={onRowClick}
                    onExporting={onExporting}
                    allowColumnReordering
                    showBorders
                    ref={gridRef}
                    remoteOperations={true}
                >
                    <LoadPanel showPane={false} />
                    <SearchPanel visible placeholder='Benutzer suchen' />
                    <Export enabled allowExportSelectedData formats={exportFormats} />
                    <Selection
                        selectAllMode='allPages'
                        showCheckBoxesMode='always'
                        mode='multiple'
                    />
                    <HeaderFilter visible />
                    <Sorting mode='multiple' />
                    <Scrolling mode='virtual' />
                    <Toolbar>
                        <Item location='before'>
                            <div className='grid-header'>Benutzer</div>
                        </Item>
                        <Item location='before' locateInMenu='auto'>
                            <DropDownButton
                                items={filterStatusList}
                                stylingMode='text'
                                text={status}
                                dropDownOptions={dropDownOptions}
                                useSelectMode
                                onSelectionChanged={filterByStatus}
                            />
                        </Item>
                        <Item location='after' locateInMenu='auto'>
                            <Button
                                icon='plus'
                                text='Neuer Benutzer'
                                type='default'
                                stylingMode='contained'
                                onClick={onAddUserClick}
                            />
                        </Item>
                        <Item
                            location='after'
                            locateInMenu='auto'
                            showText='inMenu'
                            widget='dxButton'
                        >
                            <Button
                                icon='refresh'
                                text='Refresh'
                                stylingMode='text'
                                onClick={refresh}
                            />
                        </Item>
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='exportButton' />
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='searchPanel' locateInMenu='auto' />
                    </Toolbar>

                    <Column dataField="displayName" caption="Name" dataType="string" sortIndex={7} sortOrder='asc' hidingPriority={0} allowHiding={true} />
                    <Column dataField="mail" caption="E-Mail" dataType="string" hidingPriority={6} allowHiding={true} />
                    <Column dataField="permissiongroupId" caption="Rechtegruppe" dataType="string" hidingPriority={2} allowHiding={true} lookup={{ dataSource: dataSource_permissiongroup, valueExpr: 'permissiongroupId', displayExpr: 'permissiongroupname' }} />

                    <Column
                        dataField='status'
                        caption='Status'
                        dataType='string'
                        hidingPriority={3}
                        minWidth={100}
                        cellRender={UserStatus}
                        editCellRender={editCellStatusRender}

                    />


                </DataGrid>
                {/* <UserPanel userId={userId} isOpened={isPanelOpened} changePanelOpened={changePanelOpened} changePanelPinned={changePanelPinned} /> */}
                <FormPopup title='Neuer User' visible={popupVisible} setVisible={changePopupVisibility} onSave={onSaveClick}>
                    <UserNewForm initData={formDataDefaults} onDataChanged={onDataChanged} permissiongroupData={dataSource_permissiongroup} />
                </FormPopup>
            </div>
        </div>
    );
};